import { Component, Input } from '@angular/core'
import { UploadService } from '../../../../shared/services/upload.service'
import { UploadFileComponentModel } from './upload-file.model'

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
    @Input()
    upload: UploadFileComponentModel | undefined

    constructor(readonly uploadService: UploadService) {}
}
